export class AppLoaderState {
    isLoading: boolean = false;
    delay: number = 0;
}
